import { Injectable } from '@angular/core';
import { OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT } from '@spartacus/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {UserIdService} from "@spartacus/core";

@Injectable()
export class CurrentCustomerInterceptor implements HttpInterceptor {
  userId: string;

  constructor(protected userIdService: UserIdService) {
    this.userIdService.getUserId().subscribe(userId => this.userId = userId);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let newRequest = request;
    if (this.userId && ![OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT].includes(this.userId)) {
      const headers = request.headers.set('currentcustomer', this.userId);
      newRequest = request.clone({headers});
    }
    return next.handle(newRequest);
  }
}
